import React, { useEffect } from 'react';
import { useHistory } from 'react-router'

// Styles
import '../../assets/styles.css'

// Firebase
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default function RankingComponent() {

    const history = useHistory()

    function checkedLogedIn() {
        firebase.auth().onAuthStateChanged((user) => {
            if(!user){
                history.replace('/login')
            } else {
                getRanking()
            }
        })
    }

    function getRanking() {

        const doctorsArray = []

        firebase.firestore().collection('users').get().then((query) => {

            query.forEach(person => {
                const personData = person.data()

                if (personData.userType === 'user') {
                    doctorsArray.push(personData)
                }
            })

            doctorsArray.forEach(doctor => {
                if (doctor.earnings !== undefined) {
                    
                    doctor.earningNum = doctor.earnings.length

                } else {
                    doctor.earningNum = 0
                }
            })

            doctorsArray.sort((a, b) => (a.earningNum < b.earningNum ? 1 : -1))

            let html = ''

            doctorsArray.forEach(item => {

                html += '<li class="list-group-item">' +
                    '<b style="color: #11898F; font-size: 18px; margin-left: 10px;">' + item.fullName + '</b>' +
                    '<p style="margin-top: 20px;" >Número de pacientes: <b style="color: #FB3D44;" >' + item.earningNum + '</b></p>' +
                    '<p>ID de usuario: ' + item.appUserID + '</p>' +
                    '</li>'
            })

            document.getElementById('listBody').innerHTML = html

        })
    }

    useEffect(() => {
        checkedLogedIn()
    }, [])

    return(
        <div>
            <br></br>
            <div className="container" >
                <div className='row' >
                    <div className='col text-center' >
                        <h1 style={{ color: '#FB3D44' }} >
                            RANKING DE PERSONAL MÉDICO
                        </h1>
                    </div>
                </div>
                <div className='blue-divider' ></div>
                <br></br>

                <div className='row' >
                    <div className='col' >
                        <ol className='list-group list-group-numbered' id='listBody' >
                            
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/ranking/RankingComponent.js